import { render, staticRenderFns } from "./Orderdetails.vue?vue&type=template&id=79eb7056&scoped=true&"
import script from "./Orderdetails.vue?vue&type=script&lang=js&"
export * from "./Orderdetails.vue?vue&type=script&lang=js&"
import style0 from "./Orderdetails.vue?vue&type=style&index=0&id=79eb7056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb7056",
  null
  
)

export default component.exports